import Typography from '@mui/material/Typography';
import { noop } from 'lodash-es';
import { PropsWithChildren, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import {
	BaseDialog,
	BaseDialogProps,
} from 'library/components/controls/dialogs/BaseDialog';

type DisconnectUnitManagerDialogProps = Pick<
	BaseDialogProps,
	'title' | 'onConfirm' | 'onClose'
>;

const DisconnectUnitManagerDialog = ({
	title,
	children,
	onClose = noop,
	onConfirm = noop,
}: PropsWithChildren<DisconnectUnitManagerDialogProps>) => {
	const { t } = useTranslation(['commonButton']);

	const handleOnConfirm = useCallback(async () => {
		await onConfirm();
		onClose();
	}, [onConfirm, onClose]);

	return (
		<BaseDialog
			title={title}
			onConfirm={handleOnConfirm}
			onClose={onClose}
			closeOnConfirm
			withCloseIcon={false}
			confirmButtonText={t('commonButton:yes')}
			closeButtonText={t('commonButton:no')}>
			<Typography variant="body1">{children}</Typography>
		</BaseDialog>
	);
};

export default DisconnectUnitManagerDialog;
